/*
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2025-03-17 14:21:38
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2026-08-26 16:21:00
 * @FilePath: \qctsw-vue\packages\app\src\logic\common\issue.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { isArray } from '@qctsw/utils'
import { issueListApi } from '@/server'
import { LOAD_STATE } from '@/shared/types'
import { ISSUE_TYPE_CODE_ENUM } from '~/shared/constants'

export function logicQualityIssues() {
  const state = ref(LOAD_STATE.INIT)
  const qualityIssues = ref<{ label: string, value: number }[]>([])
  async function getQualityIssuesHandle() {
    const res = await useLoadState({
      state,
      fn: () => issueListApi({ issueTypeCode: 1 }),
    })

    if (!res || !isArray(res?.data))
      return
    qualityIssues.value = []
    res.data.forEach((v) => {
      qualityIssues.value.push({
        label: v.label,
        value: v.id,
      })
    })
  }

  return {
    state,
    qualityIssues,
    getQualityIssuesHandle,
  }
}

export interface IssueItem {
  label: string
  value: number
  children?: {
    label: string
    value: number
    energyType?: string
    partsClasszId?: number
  }[]
}
export function logicIssues(opt?: { clientOnly?: boolean }) {
  const state = ref(LOAD_STATE.INIT)
  const issues = ref<Record<ISSUE_TYPE_CODE_ENUM, IssueItem[]>>({
    [ISSUE_TYPE_CODE_ENUM.quality]: [],
    [ISSUE_TYPE_CODE_ENUM.sale]: [],
    [ISSUE_TYPE_CODE_ENUM.afterSale]: [],
    [ISSUE_TYPE_CODE_ENUM.appeal]: [],
  })
  async function getHandle() {
    const res = await useLoadState({
      state,
      key: `issues`,
      onlyClient: opt?.clientOnly || true,
      fn: () => issueListApi(),
    })

    if (!res || !isArray(res?.data))
      return
    issues.value = {
      [ISSUE_TYPE_CODE_ENUM.quality]: [],
      [ISSUE_TYPE_CODE_ENUM.sale]: [],
      [ISSUE_TYPE_CODE_ENUM.afterSale]: [],
      [ISSUE_TYPE_CODE_ENUM.appeal]: [],
    }
    for (const value of res.data) {
      if (!issues.value[value.issueTypeCode])
        return

      const item: IssueItem = {
        label: value.label,
        value: value.id,

      }
      if (value.childLs && value.childLs.length > 0) {
        item.children = value.childLs.map(v => ({
          label: v.label,
          value: v.id,
          partsClasszId: v.partsClasszId || undefined,
          energyType: v?.energyType,
        }))
      }
      issues.value[value.issueTypeCode].push(item)
    }
  }

  return {
    state,
    issues,
    getHandle,
  }
}
